var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home",staticStyle:{"margin-top":"40px"}},[_c('div',{ref:"chart",staticStyle:{"width":"860px","height":"460px","margin":"0 auto"},attrs:{"id":"main"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }